define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AudioService = void 0;
    class AudioService {
        constructor(httpRequest) {
            this.httpRequest = httpRequest;
        }
        getApplicationCookie({ conferenceId, cid, }) {
            return this.httpRequest.request({
                method: 'GET',
                path: `/application-cookie`,
                cookies: {
                    'CID': cid,
                },
                query: {
                    'conferenceId': conferenceId,
                },
                errors: {
                    400: `Bad Request`,
                },
            });
        }
        play({ url, conferenceId, accountSid, loop, cid, }) {
            return this.httpRequest.request({
                method: 'GET',
                path: `/playback/audio/play`,
                cookies: {
                    'CID': cid,
                },
                query: {
                    'url': url,
                    'conferenceId': conferenceId,
                    'accountSid': accountSid,
                    'loop': loop,
                },
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
        }
        toggle({ conferenceId, cid, }) {
            return this.httpRequest.request({
                method: 'GET',
                path: `/playback/audio/toggle`,
                cookies: {
                    'CID': cid,
                },
                query: {
                    'conferenceId': conferenceId,
                },
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
        }
        stop({ conferenceId, cid, }) {
            return this.httpRequest.request({
                method: 'GET',
                path: `/playback/audio/stop`,
                cookies: {
                    'CID': cid,
                },
                query: {
                    'conferenceId': conferenceId,
                },
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
        }
        changeVolume({ conferenceId, volume, cid, }) {
            return this.httpRequest.request({
                method: 'GET',
                path: `/playback/audio/volume`,
                cookies: {
                    'CID': cid,
                },
                query: {
                    'conferenceId': conferenceId,
                    'volume': volume,
                },
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
        }
    }
    exports.AudioService = AudioService;
});
